export default {
  contractName: "PixelChainCore",
  abi: [
    {
      inputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "approved",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "ApprovalForAll",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint256",
          name: "id",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "address",
          name: "author",
          type: "address",
        },
        {
          indexed: false,
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "data",
          type: "bytes",
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "palette",
          type: "bytes",
        },
      ],
      name: "PixelChainCreated",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "baseURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "getApproved",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "operator",
          type: "address",
        },
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "isOwner",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "ownerOf",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      name: "pixelChains",
      outputs: [
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes",
        },
        {
          internalType: "bytes",
          name: "palette",
          type: "bytes",
        },
        {
          internalType: "address",
          name: "author",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "date",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
      ],
      name: "safeTransferFrom",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "bool",
          name: "approved",
          type: "bool",
        },
      ],
      name: "setApprovalForAll",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4",
        },
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "index",
          type: "uint256",
        },
      ],
      name: "tokenOfOwnerByIndex",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "tokenId",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "_tokenId",
          type: "uint256",
        },
      ],
      name: "tokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "string",
          name: "_name",
          type: "string",
        },
        {
          internalType: "bytes",
          name: "_data",
          type: "bytes",
        },
        {
          internalType: "bytes",
          name: "_palette",
          type: "bytes",
        },
      ],
      name: "create",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: true,
      stateMutability: "payable",
      type: "function",
    },
    {
      constant: true,
      inputs: [
        {
          internalType: "uint256",
          name: "_id",
          type: "uint256",
        },
      ],
      name: "retrieve",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
        {
          internalType: "bytes",
          name: "",
          type: "bytes",
        },
        {
          internalType: "bytes",
          name: "",
          type: "bytes",
        },
        {
          internalType: "address",
          name: "",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "string",
          name: "_uri",
          type: "string",
        },
      ],
      name: "setBaseTokenURI",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [],
      name: "withdraw",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: false,
      inputs: [
        {
          internalType: "uint256",
          name: "_price",
          type: "uint256",
        },
      ],
      name: "setMintPrice",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "baseTokenURI",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      payable: false,
      stateMutability: "view",
      type: "function",
    },
  ],
  metadata:
    '{"compiler":{"version":"0.5.17+commit.d19bba13"},"language":"Solidity","output":{"abi":[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"address","name":"author","type":"address"},{"indexed":false,"internalType":"string","name":"name","type":"string"},{"indexed":false,"internalType":"bytes","name":"data","type":"bytes"},{"indexed":false,"internalType":"bytes","name":"palette","type":"bytes"}],"name":"PixelChainCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"baseTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"bytes","name":"_data","type":"bytes"},{"internalType":"bytes","name":"_palette","type":"bytes"}],"name":"create","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"pixelChains","outputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"bytes","name":"data","type":"bytes"},{"internalType":"bytes","name":"palette","type":"bytes"},{"internalType":"address","name":"author","type":"address"},{"internalType":"uint256","name":"date","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"retrieve","outputs":[{"internalType":"string","name":"","type":"string"},{"internalType":"bytes","name":"","type":"bytes"},{"internalType":"bytes","name":"","type":"bytes"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"_uri","type":"string"}],"name":"setBaseTokenURI","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setMintPrice","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}],"devdoc":{"methods":{"approve(address,uint256)":{"details":"Approves another address to transfer the given token ID The zero address indicates there is no approved address. There can only be one approved address per token at a given time. Can only be called by the token owner or an approved operator.","params":{"to":"address to be approved for the given token ID","tokenId":"uint256 ID of the token to be approved"}},"balanceOf(address)":{"details":"Gets the balance of the specified address.","params":{"owner":"address to query the balance of"},"return":"uint256 representing the amount owned by the passed address"},"baseURI()":{"details":"Returns the base URI set via {_setBaseURI}. This will be automatically added as a preffix in {tokenURI} to each token\'s URI, when they are non-empty.    * _Available since v2.5.0._"},"getApproved(uint256)":{"details":"Gets the approved address for a token ID, or zero if no address set Reverts if the token ID does not exist.","params":{"tokenId":"uint256 ID of the token to query the approval of"},"return":"address currently approved for the given token ID"},"isApprovedForAll(address,address)":{"details":"Tells whether an operator is approved by a given owner.","params":{"operator":"operator address which you want to query the approval of","owner":"owner address which you want to query the approval of"},"return":"bool whether the given operator is approved by the given owner"},"isOwner()":{"details":"Returns true if the caller is the current owner."},"owner()":{"details":"Returns the address of the current owner."},"ownerOf(uint256)":{"details":"Gets the owner of the specified token ID.","params":{"tokenId":"uint256 ID of the token to query the owner of"},"return":"address currently marked as the owner of the given token ID"},"renounceOwnership()":{"details":"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner.     * NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."},"safeTransferFrom(address,address,uint256)":{"details":"Safely transfers the ownership of a given token ID to another address If the target address is a contract, it must implement {IERC721Receiver-onERC721Received}, which is called upon a safe transfer, and return the magic value `bytes4(keccak256(\\"onERC721Received(address,address,uint256,bytes)\\"))`; otherwise, the transfer is reverted. Requires the msg.sender to be the owner, approved, or operator","params":{"from":"current owner of the token","to":"address to receive the ownership of the given token ID","tokenId":"uint256 ID of the token to be transferred"}},"safeTransferFrom(address,address,uint256,bytes)":{"details":"Safely transfers the ownership of a given token ID to another address If the target address is a contract, it must implement {IERC721Receiver-onERC721Received}, which is called upon a safe transfer, and return the magic value `bytes4(keccak256(\\"onERC721Received(address,address,uint256,bytes)\\"))`; otherwise, the transfer is reverted. Requires the _msgSender() to be the owner, approved, or operator","params":{"_data":"bytes data to send along with a safe transfer check","from":"current owner of the token","to":"address to receive the ownership of the given token ID","tokenId":"uint256 ID of the token to be transferred"}},"setApprovalForAll(address,bool)":{"details":"Sets or unsets the approval of a given operator An operator is allowed to transfer all tokens of the sender on their behalf.","params":{"approved":"representing the status of the approval to be set","to":"operator address to set the approval"}},"supportsInterface(bytes4)":{"details":"See {IERC165-supportsInterface}.     * Time complexity O(1), guaranteed to always use less than 30 000 gas."},"tokenByIndex(uint256)":{"details":"Gets the token ID at a given index of all the tokens in this contract Reverts if the index is greater or equal to the total number of tokens.","params":{"index":"uint256 representing the index to be accessed of the tokens list"},"return":"uint256 token ID at the given index of the tokens list"},"tokenOfOwnerByIndex(address,uint256)":{"details":"Gets the token ID at a given index of the tokens list of the requested owner.","params":{"index":"uint256 representing the index to be accessed of the requested tokens list","owner":"address owning the tokens list to be accessed"},"return":"uint256 token ID at the given index of the tokens list owned by the requested address"},"totalSupply()":{"details":"Gets the total amount of tokens stored by the contract.","return":"uint256 representing the total amount of tokens"},"transferFrom(address,address,uint256)":{"details":"Transfers the ownership of a given token ID to another address. Usage of this method is discouraged, use {safeTransferFrom} whenever possible. Requires the msg.sender to be the owner, approved, or operator.","params":{"from":"current owner of the token","to":"address to receive the ownership of the given token ID","tokenId":"uint256 ID of the token to be transferred"}},"transferOwnership(address)":{"details":"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."}}},"userdoc":{"methods":{}}},"settings":{"compilationTarget":{"/home/scarullo/Development/cryptopixel-ethereum/contracts/PixelChainCore.sol":"PixelChainCore"},"evmVersion":"istanbul","libraries":{},"optimizer":{"enabled":true,"runs":200},"remappings":[]},"sources":{"/home/scarullo/Development/cryptopixel-ethereum/contracts/PixelChainCore.sol":{"keccak256":"0xe4b9686349f43f788d9e02874e18d5aa6ea3398d3aa8d5455430589845562887","urls":["bzz-raw://f8514289c717b5d3649cff011c9b7868fe7c0d27514300bd2a3e5321fd2e122e","dweb:/ipfs/QmNMRLaTBCHAZmsqto7EbEHRqh4PtuBMu8EwnGiD2Z3DYe"]},"/home/scarullo/Development/cryptopixel-ethereum/contracts/Strings.sol":{"keccak256":"0xbb33f0ca4a6b54061140e5ae292a0a526d29039c3bb8f9f6b252288adda002c3","urls":["bzz-raw://9afe107704551999aacf932096be58a851a6511f333248c1cdebbf83c30874b5","dweb:/ipfs/QmaEf3TAYMC2qqveTCepKQN9qsy7ueUxMpxwTaVJRNaf2X"]},"@openzeppelin/contracts/GSN/Context.sol":{"keccak256":"0x90a3995645af7562d84b9d69363ffa5ae7217714ab61e951bf7bc450f40e4061","urls":["bzz-raw://216ef9d6b614db4eb46970b4e84903f2534a45572dd30a79f0041f1a5830f436","dweb:/ipfs/QmNPrJ4MWKUAWzKXpUqeyKRUfosaoANZAqXgvepdrCwZAG"]},"@openzeppelin/contracts/drafts/Counters.sol":{"keccak256":"0x5be8533c5950173dc2b77b75108fae6e6c5449aedadde3385ba457394aad2384","urls":["bzz-raw://d429fb04f5b31d909dc759d0f88e28055b80b4dd43e5def4dffc947fa0609229","dweb:/ipfs/QmaY9idX5CwLLtjjTQAdiiaDSrncgafkatUZXTbbajpz8b"]},"@openzeppelin/contracts/introspection/ERC165.sol":{"keccak256":"0x01aedbf24e121a744262e04c7815b2a4c8ce604dee4829c5cff00943a594ccf3","urls":["bzz-raw://999ab32a6498d8ad8db61d47c3774aae2ff919acceebe2aeb50879bef62642c3","dweb:/ipfs/QmephAYF5hoymu9qCFK6mURM2kZJCxU4ntUb4KTf1miVPT"]},"@openzeppelin/contracts/introspection/IERC165.sol":{"keccak256":"0xe0ed10f53955c35eecb02724538650a155aa940be3f0a54cd3bde6c6b0c6e48c","urls":["bzz-raw://7dcfda88e3225987245908c3296f3559752647036804325ebfaa9fd1545161c3","dweb:/ipfs/QmXxx5rHfLL57zdgyyyG9MMv4XGN7bpVSc2MuDcaCgto6u"]},"@openzeppelin/contracts/math/SafeMath.sol":{"keccak256":"0x640b6dee7a4b830bdfd52b5031a07fc2b12209f5b2e29e5d364a7d37f69d8076","urls":["bzz-raw://31113152e1ddb78fe7a4197f247591ca894e93f916867beb708d8e747b6cc74f","dweb:/ipfs/QmbZaJyXdpsYGykVhHH9qpVGQg9DGCxE2QufbCUy3daTgq"]},"@openzeppelin/contracts/ownership/Ownable.sol":{"keccak256":"0x6fb9d7889769d7cc161225f9ef7a90e468ba9788b253816f8d8b6894d3472c24","urls":["bzz-raw://cf4c00fc3c37cc5acf0c82ec6fd97bab67d72c2567fdc0ebf023d9c09b30a08e","dweb:/ipfs/Qmb7TChG6DsEDX7LooJ4vmxot19f7VXX8S1zUGPeJTWbwZ"]},"@openzeppelin/contracts/token/ERC721/ERC721.sol":{"keccak256":"0x1a1c02bc2487c763ad240f6b6440ec9dcb84870879aea3ed2a6b9cd300b637c7","urls":["bzz-raw://e6351696020fecf1c1b09437a2961cbdc3e1579238a9573b8577b58af463eeb6","dweb:/ipfs/QmTg7UxUcuENko38JL2Pb2aqXkWgqW1xPDbJwmfo3RVrrV"]},"@openzeppelin/contracts/token/ERC721/ERC721Enumerable.sol":{"keccak256":"0x28f4e41b86db783cd8daf9fdec839ce5930332b60f6dc9ac4992dfb584997e79","urls":["bzz-raw://6f1b545ec9e1f0284e86ddd4ffff353e1ab5e026bbbfaa2a5d2d791c39d7afd7","dweb:/ipfs/Qmf9rVfj6LreiE7NHkkT1S7eLbSQDDY1gKd9XWERx2AN7W"]},"@openzeppelin/contracts/token/ERC721/ERC721Full.sol":{"keccak256":"0x307231237999e19b618a03e7ecff1cee2a189dd019ebd203e5e43a63a7ac8aa3","urls":["bzz-raw://9a169446f024a24c3e5146cbeefea6be3bbbe9ba836f98f9d0c64af9f10773c4","dweb:/ipfs/QmWibincTepM31suKeF6bd3shbPGjc9E7uULaXQBY1eNX5"]},"@openzeppelin/contracts/token/ERC721/ERC721Metadata.sol":{"keccak256":"0xe454aab4894511c610fb28e63e212608004921c10dfbffaf0b0e18a2c3b204eb","urls":["bzz-raw://cbb33c4aa1ba8470e389a79702b1b0450c03acd0e9471ed3ae5d566a958d36a4","dweb:/ipfs/QmXryp8Ncftr8WYt7vWwoFQVKnbxtQ7dQBHzfzgWWYGisK"]},"@openzeppelin/contracts/token/ERC721/IERC721.sol":{"keccak256":"0x680c11bc8173eef7d5db843baaf64ce499476de2c172f6aea631dbee54bcd2e6","urls":["bzz-raw://0f314963ab26fb65c6f364d57900f0f1aa8f6aeb4396e327e5e5c646815f060e","dweb:/ipfs/Qmf6eSUtRUF4YDxGyhQq7TVDYzuHcYEvk9Us3RVy5iZQVH"]},"@openzeppelin/contracts/token/ERC721/IERC721Enumerable.sol":{"keccak256":"0x5c573acd6c7b98d71f3c1c44d63dc17400b0fd7b26a52c9fded43b8b533dc4ec","urls":["bzz-raw://e23af54444d2dbfae58895339eb7b189e1ba5d0b7abde63716e7ef7da23b2fde","dweb:/ipfs/QmZva7dE1SMd1yyizzc6ivSoBXXwpNveLV7iFNATNpq68Y"]},"@openzeppelin/contracts/token/ERC721/IERC721Metadata.sol":{"keccak256":"0x2b2b99dc7fe8fcd1f9427d00822b99cbc683dc21f5dd7532bd7e2281fd2c2ca2","urls":["bzz-raw://a8024c00e34efaf328f9592e76823c79f25fa0f6006bdf4a1e7fea204afd4773","dweb:/ipfs/QmZns9jTr7843njq3J2iL2LLoWXK5mdzN1bDGd9GL3ahhD"]},"@openzeppelin/contracts/token/ERC721/IERC721Receiver.sol":{"keccak256":"0x042048c375daca04b31e31c91bbae912b84b5eb818c4e31b2deb530fd2305342","urls":["bzz-raw://d877a87c5e29b9ffca3e334378058c051a4e012fd3635039681003a9376baf1f","dweb:/ipfs/QmR45snf93cFXtB71TZcmoGy9DbcMha8CqgkDKaLvhjXZK"]},"@openzeppelin/contracts/utils/Address.sol":{"keccak256":"0x1a8e5072509c5ea7365eb1d48030b9be865140c8fb779968da0a459a0e174a11","urls":["bzz-raw://03335b7b07c7c8c8d613cfdd8ec39a0b5ec133ee510bf2fe6cc5a496767bef4b","dweb:/ipfs/Qmebp4nzPja645c9yXSdJkGq96oU3am3LUnG2K3R7XxyKf"]}},"version":1}',
  bytecode:
    "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",
  deployedBytecode:
    "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",
  sourceMap:
    "316:33:1:-;168:2111;316:33;;168:2111;316:33;;;-1:-1:-1;;;316:33:1;;;;;;;;;;:::i;:::-;-1:-1:-1;355:28:1;;;;;;;;;;;;;-1:-1:-1;;;355:28:1;;;;;;;;;;;;:::i;:::-;-1:-1:-1;389:24:1;;;;;;;;;;-1:-1:-1;389:24:1;;;;;;;;;:::i;:::-;;439:1;419:21;;626:49;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;651:4:1;456:155:11;;;;;;;;;;;;;-1:-1:-1;;456:155:11;;;;;;;;;;;;;;;;;;;;;;;;;;;651:4:1;456:155:11;;651:4:1;456:155:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;657:6:1;456:155:11;;;;;;;;-1:-1:-1;;456:155:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;657:6:1;;-1:-1:-1;456:155:11;-1:-1:-1;456:155:11;;657:6:1;456:155:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;533:4;539:6;698:17:8;718:12;:10;;;:12;;:::i;:::-;740:6;:18;;-1:-1:-1;;;;;;740:18:8;-1:-1:-1;;;;;740:18:8;;;;;;;773:43;;740:18;;-1:-1:-1;740:18:8;773:43;;740:6;;773:43;-1:-1:-1;718:40:5;-1:-1:-1;;;;;;;;718:18:5;:40;:::i;:::-;2262::9;-1:-1:-1;;;;;;;;2262:18:9;:40;:::i;:::-;1357:51:10;-1:-1:-1;;;;;;;;1357:18:10;:51;:::i;:::-;912:12:12;;;;:5;;:12;;;;;:::i;:::-;-1:-1:-1;934:16:12;;;;:7;;:16;;;;;:::i;:::-;-1:-1:-1;1038:49:12;-1:-1:-1;;;;;;;;1038:18:12;:49;:::i;:::-;840:254;;456:155:11;;168:2111:1;;788:96:3;867:10;788:96;;:::o;1442:190:5:-;-1:-1:-1;;;;;;1517:25:5;;;;;1509:66;;;;;-1:-1:-1;;;1509:66:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;1585:33:5;;;;;1621:4;1585:33;;;;;;;;:40;;-1:-1:-1;;1585:40:5;;;;;;1442:190::o;168:2111:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;168:2111:1;;;-1:-1:-1;168:2111:1;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;",
  deployedSourceMap:
    "168:2111:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;915:133:5;;8:9:-1;5:2;;;30:1;27;20:12;5:2;915:133:5;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;915:133:5;-1:-1:-1;;;;;;915:133:5;;:::i;:::-;;;;;;;;;;;;;;;;;;316:33:1;;8:9:-1;5:2;;;30:1;27;20:12;5:2;316:33:1;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:100:-1;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;316:33:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4283:200:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4283:200:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;4283:200:9;;:::i;:::-;;;;-1:-1:-1;;;;;4283:200:9;;;;;;;;;;;;;;3583:415;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3583:415:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;3583:415:9;;;;;;;;:::i;:::-;;2171:94:10;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2171:94:10;;;:::i;:::-;;;;;;;;;;;;;;;;5929:287:9;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5929:287:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;5929:287:9;;;;;;;;;;;;;;;;;:::i;1789:229:10:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1789:229:10;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;1789:229:10;;;;;;;;:::i;1874:98:1:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1874:98:1;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1874:98:1;;;;;;;;-1:-1:-1;;;5:28;;2:2;;;46:1;43;36:12;2:2;1874:98:1;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;1874:98:1;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;-1:-1;;;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;1874:98:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;81:16;;74:27;;;;-1:-1;1874:98:1;;-1:-1:-1;1874:98:1;;-1:-1:-1;;;;;1874:98:1:i;1978:::-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1978:98:1;;;:::i;6865:132:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6865:132:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;6865:132:9;;;;;;;;;;;;;;;;;:::i;2603:196:10:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2603:196:10;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;2603:196:10;;:::i;2939:223:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2939:223:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;2939:223:9;;:::i;3387:89:12:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3387:89:12;;;:::i;2513:207:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2513:207:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;2513:207:9;-1:-1:-1;;;;;2513:207:9;;:::i;588:31:1:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;588:31:1;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;588:31:1;;:::i;:::-;;;;;;;;;;;;;;-1:-1:-1;;;;;588:31:1;-1:-1:-1;;;;;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;588:31:1;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;588:31:1;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1684:137:8;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1684:137:8;;;:::i;899:77::-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;899:77:8;;;:::i;1250:92::-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1250:92:8;;;:::i;1610:258:1:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1610:258:1;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;1610:258:1;;:::i;355:28::-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;355:28:1;;;:::i;4776:249:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4776:249:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;4776:249:9;;;;;;;;;;:::i;906:698:1:-;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;906:698:1;;;;;;;;-1:-1:-1;;;5:28;;2:2;;;46:1;43;36:12;2:2;906:698:1;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;906:698:1;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;-1:-1;;;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;906:698:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;81:16;;74:27;;;;-1:-1;906:698:1;;;;;;;;-1:-1:-1;906:698:1;;-1:-1:-1;;;;;5:28;;2:2;;;46:1;43;36:12;2:2;906:698:1;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;906:698:1;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;-1:-1;;;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;906:698:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;81:16;;74:27;;;;-1:-1;906:698:1;;;;;;;;-1:-1:-1;906:698:1;;-1:-1:-1;;;;;5:28;;2:2;;;46:1;43;36:12;2:2;906:698:1;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;906:698:1;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;-1:-1;;;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;906:698:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;81:16;;74:27;;;;-1:-1;906:698:1;;-1:-1:-1;906:698:1;;-1:-1:-1;;;;;906:698:1:i;7720:269:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;7720:269:9;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;-1:-1;;;;;7720:269:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;5:28;;2:2;;;46:1;43;36:12;2:2;7720:269:9;;35:9:-1;28:4;12:14;8:25;5:40;2:2;;;58:1;55;48:12;2:2;7720:269:9;;;;;;100:9:-1;95:1;81:12;77:20;67:8;63:35;60:50;-1:-1;;;25:12;22:29;11:107;8:2;;;131:1;128;121:12;8:2;7720:269:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;30:3:-1;22:6;14;1:33;99:1;81:16;;74:27;;;;-1:-1;7720:269:9;;-1:-1:-1;7720:269:9;;-1:-1:-1;;;;;7720:269:9:i;681:193:1:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;681:193:1;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;681:193:1;;:::i;2180:96::-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2180:96:1;;;:::i;5347:145:9:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5347:145:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;;;;;;5347:145:9;;;;;;;;;;:::i;1970:107:8:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1970:107:8;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;1970:107:8;-1:-1:-1;;;;;1970:107:8;;:::i;2082:92:1:-;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2082:92:1;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;2082:92:1;;:::i;915:133:5:-;-1:-1:-1;;;;;;1008:33:5;;985:4;1008:33;;;:20;:33;;;;;;;;915:133;;;;:::o;316:33:1:-;;;;;;;;;;;;;;;-1:-1:-1;;316:33:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;4283:200:9:-;4342:7;4369:16;4377:7;4369;:16::i;:::-;4361:73;;;;-1:-1:-1;;;4361:73:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;4452:24:9;;;;:15;:24;;;;;;-1:-1:-1;;;;;4452:24:9;;4283:200::o;3583:415::-;3646:13;3662:16;3670:7;3662;:16::i;:::-;3646:32;;3702:5;-1:-1:-1;;;;;3696:11:9;:2;-1:-1:-1;;;;;3696:11:9;;;3688:57;;;;-1:-1:-1;;;3688:57:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3780:5;-1:-1:-1;;;;;3764:21:9;:12;:10;:12::i;:::-;-1:-1:-1;;;;;3764:21:9;;:62;;;;3789:37;3806:5;3813:12;:10;:12::i;:::-;3789:16;:37::i;:::-;3756:152;;;;-1:-1:-1;;;3756:152:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3919:24;;;;:15;:24;;;;;;:29;;-1:-1:-1;;;;;;3919:29:9;-1:-1:-1;;;;;3919:29:9;;;;;;;;;3963:28;;3919:24;;3963:28;;;;;;;3583:415;;;:::o;2171:94:10:-;2241:10;:17;2171:94;;:::o;5929:287:9:-;6071:41;6090:12;:10;:12::i;:::-;6104:7;6071:18;:41::i;:::-;6063:103;;;;-1:-1:-1;;;6063:103:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6177:32;6191:4;6197:2;6201:7;6177:13;:32::i;:::-;5929:287;;;:::o;1789:229:10:-;1869:7;1904:16;1914:5;1904:9;:16::i;:::-;1896:5;:24;1888:80;;;;-1:-1:-1;;;1888:80:10;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;1985:19:10;;;;;;:12;:19;;;;;:26;;2005:5;;1985:26;;;;;;;;;;;;;;1978:33;;1789:229;;;;:::o;1874:98:1:-;1103:9:8;:7;:9::i;:::-;1095:54;;;;;-1:-1:-1;;;1095:54:8;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;1095:54:8;;;;;;;;;;;;;;;1946:19:1;;;;:12;;:19;;;;;:::i;:::-;;1874:98;:::o;1978:::-;1103:9:8;:7;:9::i;:::-;1095:54;;;;;-1:-1:-1;;;1095:54:8;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;1095:54:8;;;;;;;;;;;;;;;2027:42:1;;:10;;2047:21;2027:42;;;;;;;;;2047:21;2027:10;:42;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;2027:42:1;1978:98::o;6865:132:9:-;6951:39;6968:4;6974:2;6978:7;6951:39;;;;;;;;;;;;:16;:39::i;2603:196:10:-;2661:7;2696:13;:11;:13::i;:::-;2688:5;:21;2680:78;;;;-1:-1:-1;;;2680:78:10;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2775:10;2786:5;2775:17;;;;;;;;;;;;;;;;2768:24;;2603:196;;;:::o;2939:223:9:-;2994:7;3029:20;;;:11;:20;;;;;;-1:-1:-1;;;;;3029:20:9;3067:19;3059:73;;;;-1:-1:-1;;;3059:73:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3150:5;2939:223;-1:-1:-1;;2939:223:9:o;3387:89:12:-;3461:8;3454:15;;;;;;;;-1:-1:-1;;3454:15:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3429:13;;3454:15;;3461:8;;3454:15;;3461:8;3454:15;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3387:89;:::o;2513:207:9:-;2568:7;-1:-1:-1;;;;;2595:19:9;;2587:74;;;;-1:-1:-1;;;2587:74:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;2679:24:9;;;;;;:17;:24;;;;;:34;;:32;:34::i;588:31:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;588:31:1;;;;;;;;;;;-1:-1:-1;;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;588:31:1;;-1:-1:-1;588:31:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;588:31:1;;;;;;;;;;;-1:-1:-1;;;;;588:31:1;;;-1:-1:-1;588:31:1;:::o;1684:137:8:-;1103:9;:7;:9::i;:::-;1095:54;;;;;-1:-1:-1;;;1095:54:8;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;1095:54:8;;;;;;;;;;;;;;;1782:1;1766:6;;1745:40;;-1:-1:-1;;;;;1766:6:8;;;;1745:40;;1782:1;;1745:40;1812:1;1795:19;;-1:-1:-1;;;;;;1795:19:8;;;1684:137::o;899:77::-;937:7;963:6;-1:-1:-1;;;;;963:6:8;899:77;:::o;1250:92::-;1290:4;1329:6;;-1:-1:-1;;;;;1329:6:8;1313:12;:10;:12::i;:::-;-1:-1:-1;;;;;1313:22:8;;1306:29;;1250:92;:::o;1610:258:1:-;1663:13;1678:12;1692;1706:7;1715;1742:11;1754:3;1742:16;;;;;;;;;;;;;;;;;;:21;;1765:11;1777:3;1765:16;;;;;;;;;;;;;;;;;;:21;;1788:11;1800:3;1788:16;;;;;;;;;;;;;;;;;;:24;;1814:11;1826:3;1814:16;;;;;;;;;;;;;;;;;;:23;;;;;;;;;;-1:-1:-1;;;;;1814:23:1;1839:11;1851:3;1839:16;;;;;;;;;;;;;;;;;:21;:16;;;;;:21;;1734:127;;;;;;;-1:-1:-1;;1734:127:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1839:21;;1734:127;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;1734:127:1;;;;;;;;;;;;;-1:-1:-1;;1734:127:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1734:127:1;;-1:-1:-1;1734:127:1;-1:-1:-1;1734:127:1;;;-1:-1:-1;1734:127:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;1734:127:1;;;;;;;;;;;;;-1:-1:-1;;1734:127:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1734:127:1;;-1:-1:-1;1734:127:1;-1:-1:-1;1734:127:1;;;-1:-1:-1;1734:127:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1610:258;;;;;;;:::o;355:28::-;;;;;;;;;;;;;;;-1:-1:-1;;355:28:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4776:249:9;4861:12;:10;:12::i;:::-;-1:-1:-1;;;;;4855:18:9;:2;-1:-1:-1;;;;;4855:18:9;;;4847:56;;;;;-1:-1:-1;;;4847:56:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;4953:8;4914:18;:32;4933:12;:10;:12::i;:::-;-1:-1:-1;;;;;4914:32:9;;;;;;;;;;;;;;;;;-1:-1:-1;4914:32:9;;;:36;;;;;;;;;;;;:47;;-1:-1:-1;;4914:47:9;;;;;;;;;;;4991:12;:10;:12::i;:::-;4976:42;;;;;;;;;;-1:-1:-1;;;;;4976:42:9;;;;;;;;;;;;;;4776:249;;:::o;906:698:1:-;1010:4;1047:9;;1034;:22;;1026:71;;;;-1:-1:-1;;;1026:71:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1115:5;:12;1131:4;1115:20;1107:73;;;;-1:-1:-1;;;1107:73:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1198:8;:15;1217:2;1198:21;1190:75;;;;-1:-1:-1;;;1190:75:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1292:9;;1280;:21;1276:94;;;1349:9;;1317:42;;:10;;1337:9;:21;1317:42;;;;;;;;;1337:21;1317:10;:42;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1317:42:1;1276:94;1407:63;;;;;;;;;;;;;;;;;;;;;;;;1442:10;1407:63;;;;1454:15;1407:63;;;;1390:11;27:10:-1;;1474:1:1;23:18:-1;;;45:23;;;1380:7:1;1390:81;;;;;;;1380:7;;1474:1;;23:18:-1;;1407:63:1;;1390:81;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;1390:81:1;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;1390:81:1;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;1390:81:1;;;;;;;;;-1:-1:-1;;;;;;1390:81:1;-1:-1:-1;;;;;1390:81:1;;;;;;;;;;;;;;;;;;;:85;;-1:-1:-1;1485:21:1;1491:10;1390:85;1485:5;:21::i;:::-;1521:57;1539:2;1543:10;1555:5;1562;1569:8;1521:57;;;;;;;;;-1:-1:-1;;;;;1521:57:1;-1:-1:-1;;;;;1521:57:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;1521:57:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1521:57:1;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;1521:57:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1521:57:1;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;1521:57:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1595:2;906:698;-1:-1:-1;;;;906:698:1:o;7720:269:9:-;7834:41;7853:12;:10;:12::i;:::-;7867:7;7834:18;:41::i;:::-;7826:103;;;;-1:-1:-1;;;7826:103:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7939:43;7957:4;7963:2;7967:7;7976:5;7939:17;:43::i;:::-;7720:269;;;;:::o;681:193:1:-;740:13;772:95;803:14;:12;:14::i;:::-;831:26;848:8;831:16;:26::i;:::-;772:17;:95::i;2180:96::-;2257:12;2250:19;;;;;;;;-1:-1:-1;;2250:19:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2225:13;;2250:19;;2257:12;;2250:19;;2257:12;2250:19;;;;;;;;;;;;;;;;;;;;;;;;5347:145:9;-1:-1:-1;;;;;5450:25:9;;;5427:4;5450:25;;;:18;:25;;;;;;;;:35;;;;;;;;;;;;;;;5347:145::o;1970:107:8:-;1103:9;:7;:9::i;:::-;1095:54;;;;;-1:-1:-1;;;1095:54:8;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;1095:54:8;;;;;;;;;;;;;;;2042:28;2061:8;2042:18;:28::i;2082:92:1:-;1103:9:8;:7;:9::i;:::-;1095:54;;;;;-1:-1:-1;;;1095:54:8;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;1095:54:8;;;;;;;;;;;;;;;2149:9:1;:18;2082:92::o;9158:152:9:-;9215:4;9247:20;;;:11;:20;;;;;;-1:-1:-1;;;;;9247:20:9;9284:19;;;9158:152::o;788:96:3:-;867:10;788:96;:::o;9671:329:9:-;9756:4;9780:16;9788:7;9780;:16::i;:::-;9772:73;;;;-1:-1:-1;;;9772:73:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9855:13;9871:16;9879:7;9871;:16::i;:::-;9855:32;;9916:5;-1:-1:-1;;;;;9905:16:9;:7;-1:-1:-1;;;;;9905:16:9;;:51;;;;9949:7;-1:-1:-1;;;;;9925:31:9;:20;9937:7;9925:11;:20::i;:::-;-1:-1:-1;;;;;9925:31:9;;9905:51;:87;;;;9960:32;9977:5;9984:7;9960:16;:32::i;:::-;9897:96;9671:329;-1:-1:-1;;;;9671:329:9:o;3174:239:10:-;3259:38;3279:4;3285:2;3289:7;3259:19;:38::i;:::-;3308:47;3341:4;3347:7;3308:32;:47::i;:::-;3366:40;3394:2;3398:7;3366:27;:40::i;1065:112:4:-;1156:14;;1065:112::o;3670:196:10:-;3733:24;3745:2;3749:7;3733:11;:24::i;:::-;3768:40;3796:2;3800:7;3768:27;:40::i;:::-;3819;3851:7;3819:31;:40::i;8694:269:9:-;8803:32;8817:4;8823:2;8827:7;8803:13;:32::i;:::-;8853:48;8876:4;8882:2;8886:7;8895:5;8853:22;:48::i;:::-;8845:111;;;;-1:-1:-1;;;8845:111:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1500:465:2;1550:27;1593:7;1589:48;;-1:-1:-1;1616:10:2;;;;;;;;;;;;-1:-1:-1;;;1616:10:2;;;;;;1589:48;1655:2;1646:6;1685:66;1692:6;;1685:66;;1714:5;;1738:2;1733:7;;;;1685:66;;;1760:17;1790:3;1780:14;;;;;;;;;;;;;;;;;;;;;;;;;21:6:-1;;104:10;1780:14:2;87:34:-1;135:17;;-1:-1;1780:14:2;-1:-1:-1;1760:34:2;-1:-1:-1;;;1813:7:2;;1830:100;1837:7;;1830:100;;1893:2;1888;:7;1883:2;:12;1872:25;;1860:4;1865:3;;;;;;;1860:9;;;;;;;;;;;:37;-1:-1:-1;;;;;1860:37:2;;;;;;;;-1:-1:-1;1917:2:2;1911:8;;;;1830:100;;;-1:-1:-1;1953:4:2;1500:465;-1:-1:-1;;;;1500:465:2:o;1348:146::-;1426:13;1458:29;1468:2;1472;1458:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:9;:29::i;:::-;1451:36;1348:146;-1:-1:-1;;;1348:146:2:o;2178:225:8:-;-1:-1:-1;;;;;2251:22:8;;2243:73;;;;-1:-1:-1;;;2243:73:8;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2352:6;;;2331:38;;-1:-1:-1;;;;;2331:38:8;;;;2352:6;;;2331:38;;;2379:6;:17;;-1:-1:-1;;;;;;2379:17:8;-1:-1:-1;;;;;2379:17:8;;;;;;;;;;2178:225::o;13281:447:9:-;13394:4;-1:-1:-1;;;;;13374:24:9;:16;13382:7;13374;:16::i;:::-;-1:-1:-1;;;;;13374:24:9;;13366:78;;;;-1:-1:-1;;;13366:78:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13462:16:9;;13454:65;;;;-1:-1:-1;;;13454:65:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13530:23;13545:7;13530:14;:23::i;:::-;-1:-1:-1;;;;;13564:23:9;;;;;;:17;:23;;;;;:35;;:33;:35::i;:::-;-1:-1:-1;;;;;13609:21:9;;;;;;:17;:21;;;;;:33;;:31;:33::i;:::-;13653:20;;;;:11;:20;;;;;;:25;;-1:-1:-1;;;;;;13653:25:9;-1:-1:-1;;;;;13653:25:9;;;;;;;;;13694:27;;13653:20;;13694:27;;;;;;;13281:447;;;:::o;6284:1128:10:-;-1:-1:-1;;;;;6571:18:10;;6546:22;6571:18;;;:12;:18;;;;;:25;:32;;6601:1;6571:32;:29;:32;:::i;:::-;6613:18;6634:26;;;:17;:26;;;;;;6546:57;;-1:-1:-1;6764:28:10;;;6760:323;;-1:-1:-1;;;;;6830:18:10;;6808:19;6830:18;;;:12;:18;;;;;:34;;6849:14;;6830:34;;;;;;;;;;;;;;6808:56;;6912:11;6879:12;:18;6892:4;-1:-1:-1;;;;;6879:18:10;-1:-1:-1;;;;;6879:18:10;;;;;;;;;;;;6898:10;6879:30;;;;;;;;;;;;;;;;;;;:44;;;;6995:30;;;:17;:30;;;;;:43;;;6760:323;-1:-1:-1;;;;;7169:18:10;;;;;;:12;:18;;;;;:27;;;;;-1:-1:-1;;7169:27:10;;;:::i;:::-;;6284:1128;;;;:::o;5128:183::-;-1:-1:-1;;;;;5241:16:10;;;;;;;:12;:16;;;;;;;;:23;;5212:26;;;:17;:26;;;;;:52;;;5274:16;;;39:1:-1;23:18;;45:23;;5274:30:10;;;;;;;;5128:183::o;11714:327:9:-;-1:-1:-1;;;;;11785:16:9;;11777:61;;;;;-1:-1:-1;;;11777:61:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11857:16;11865:7;11857;:16::i;:::-;11856:17;11848:58;;;;;-1:-1:-1;;;11848:58:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;11917:20;;;;:11;:20;;;;;;;;:25;;-1:-1:-1;;;;;;11917:25:9;-1:-1:-1;;;;;11917:25:9;;;;;;;;11952:21;;:17;:21;;;;;:33;;:31;:33::i;:::-;12001;;12026:7;;-1:-1:-1;;;;;12001:33:9;;;12018:1;;12001:33;;12018:1;;12001:33;11714:327;;:::o;5506:161:10:-;5609:10;:17;;5582:24;;;;:15;:24;;;;;:44;;;39:1:-1;23:18;;45:23;;5636:24:10;;;;;;;5506:161::o;14367:1051:9:-;14488:4;14513:15;:2;-1:-1:-1;;;;;14513:13:9;;:15::i;:::-;14508:58;;-1:-1:-1;14551:4:9;14544:11;;14508:58;14635:12;14649:23;-1:-1:-1;;;;;14676:7:9;;-1:-1:-1;;;14779:12:9;:10;:12::i;:::-;14805:4;14823:7;14844:5;14684:175;;;;;;-1:-1:-1;;;;;14684:175:9;-1:-1:-1;;;;;14684:175:9;;;;;;-1:-1:-1;;;;;14684:175:9;-1:-1:-1;;;;;14684:175:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;14684:175:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;14684:175:9;;;-1:-1:-1;;26:21;;;22:32;6:49;;14684:175:9;;;49:4:-1;25:18;;61:17;;-1:-1;;;;;182:15;-1:-1;;;;;;14684:175:9;;;179:29:-1;;;;160:49;;14676:184:9;;;14684:175;;14676:184;;-1:-1:-1;14676:184:9;;-1:-1:-1;25:18;-1:-1;14676:184:9;-1:-1:-1;14676:184:9;;-1:-1:-1;14676:184:9;;-1:-1:-1;25:18;36:153;66:2;61:3;58:11;36:153;;176:10;;164:23;;-1:-1;;139:12;;;;98:2;89:12;;;;114;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;14676:184:9;;;;;;;;;;;;;;;;;;;;;;;;14:1:-1;21;16:31;;;;75:4;69:11;64:16;;144:4;140:9;133:4;115:16;111:27;107:43;104:1;100:51;94:4;87:65;169:16;166:1;159:27;225:16;222:1;215:4;212:1;208:12;193:49;7:242;;16:31;36:4;31:9;;7:242;;14634:226:9;;;;14875:7;14870:542;;14902:17;;:21;14898:376;;15067:10;15061:17;15127:15;15114:10;15110:2;15106:19;15099:44;15016:145;15199:60;;-1:-1:-1;;;15199:60:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14870:542;15304:13;15331:10;15320:32;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;15320:32:9;-1:-1:-1;;;;;;15374:26:9;-1:-1:-1;;;15374:26:9;;-1:-1:-1;15366:35:9;;-1:-1:-1;;;15366:35:9;127:857:2;259:13;282:16;307:2;282:28;;318:16;343:2;318:28;;354:16;379:2;354:28;;390:16;415:2;390:28;;426:16;451:2;426:28;;462:19;547:3;:10;534:3;:10;521:3;:10;508:3;:10;495:3;:10;:23;:36;:49;:62;484:74;;;;;;;;;;;;;;;;;;;;;;;;;21:6:-1;;104:10;484:74:2;87:34:-1;135:17;;-1:-1;484:74:2;-1:-1:-1;462:96:2;-1:-1:-1;462:96:2;608:6;;626:58;647:3;:10;643:1;:14;626:58;;;678:3;682:1;678:6;;;;;;;;;;;;;;;;664;671:3;;;;;;664:11;;;;;;;;;;;:20;-1:-1:-1;;;;;664:20:2;;;;;;;;-1:-1:-1;659:3:2;;626:58;;;-1:-1:-1;697:6:2;692:58;713:3;:10;709:1;:14;692:58;;;744:3;748:1;744:6;;;;;;;;;;;;;;;;730;737:3;;;;;;730:11;;;;;;;;;;;:20;-1:-1:-1;;;;;730:20:2;;;;;;;;-1:-1:-1;725:3:2;;692:58;;;-1:-1:-1;763:6:2;758:58;779:3;:10;775:1;:14;758:58;;;810:3;814:1;810:6;;;;;;;;;;;;;;;;796;803:3;;;;;;796:11;;;;;;;;;;;:20;-1:-1:-1;;;;;796:20:2;;;;;;;;-1:-1:-1;791:3:2;;758:58;;;-1:-1:-1;829:6:2;824:58;845:3;:10;841:1;:14;824:58;;;876:3;880:1;876:6;;;;;;;;;;;;;;;;862;869:3;;;;;;862:11;;;;;;;;;;;:20;-1:-1:-1;;;;;862:20:2;;;;;;;;-1:-1:-1;857:3:2;;824:58;;;-1:-1:-1;895:6:2;890:58;911:3;:10;907:1;:14;890:58;;;942:3;946:1;942:6;;;;;;;;;;;;;;;;928;935:3;;;;;;928:11;;;;;;;;;;;:20;-1:-1:-1;;;;;928:20:2;;;;;;;;-1:-1:-1;923:3:2;;890:58;;;-1:-1:-1;970:6:2;;127:857;-1:-1:-1;;;;;;;;;;;;;127:857:2:o;15580:171:9:-;15679:1;15643:24;;;:15;:24;;;;;;-1:-1:-1;;;;;15643:24:9;:38;15639:106;;15732:1;15697:24;;;:15;:24;;;;;:37;;-1:-1:-1;;;;;;15697:37:9;;;15580:171::o;1367:108:4:-;1447:14;;:21;;1466:1;1447:21;:18;:21;:::i;:::-;1430:38;;1367:108::o;1183:178::-;1335:19;;1353:1;1335:19;;;1183:178::o;1274:134:7:-;1332:7;1358:43;1362:1;1365;1358:43;;;;;;;;;;;;;;;;;:3;:43::i;686:610:17:-;746:4;1207:20;;1052:66;1246:23;;;;;;:42;;-1:-1:-1;;1273:15:17;;;1238:51;-1:-1:-1;;686:610:17:o;1732:187:7:-;1818:7;1853:12;1845:6;;;;1837:29;;;;-1:-1:-1;;;1837:29:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;1837:29:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;1888:5:7;;;1732:187::o;168:2111:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;168:2111:1;;;-1:-1:-1;168:2111:1;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
  source:
    'pragma solidity ^0.5.0;\n\nimport "@openzeppelin/contracts/ownership/Ownable.sol";\nimport "@openzeppelin/contracts/token/ERC721/ERC721Full.sol";\nimport "./Strings.sol";\n\ncontract PixelChainCore is Ownable, ERC721Full {\n    event PixelChainCreated(uint id, address author, string name, bytes data, bytes palette);\n\n    string public name = "PixelChain";\n    string public symbol = "PXC";\n    string baseTokenUri = "";\n    uint256 mintPrice = 0;\n\n    struct PixelChain {\n        string name;\n        bytes data;\n        bytes palette;\n        address author;\n        uint256 date;\n    }\n\n    PixelChain[] public pixelChains;\n\n    constructor() ERC721Full(name, symbol) public { }\n\n    function tokenURI(uint256 _tokenId) external view returns (string memory) {\n        return Strings.strConcat(\n            baseTokenURI(),\n            Strings.uint2str(_tokenId)\n        );\n    }\n\n    // Management methods\n    function create(string memory _name, bytes memory _data, bytes memory _palette) public payable returns (uint) {\n        require(msg.value >= mintPrice, "Not enough ether to mint this token!");\n        require(_data.length == 1024, "The byte array length should be of 1024.");\n        require(_palette.length == 48, "The palette array length should be of 48.");\n\n        if (msg.value > mintPrice) {\n            msg.sender.transfer(msg.value - mintPrice);\n        }\n\n        uint id = pixelChains.push(PixelChain(_name, _data, _palette, msg.sender, block.timestamp)) - 1;\n        _mint(msg.sender, id);\n        emit PixelChainCreated(id, msg.sender, _name, _data, _palette);\n        return id;\n    }\n\n    function retrieve(uint256 _id) public view  returns (string memory, bytes memory, bytes memory, address, uint256) {\n        return (pixelChains[_id].name, pixelChains[_id].data, pixelChains[_id].palette, pixelChains[_id].author, pixelChains[_id].date);\n    }\n\n    function setBaseTokenURI(string memory _uri) public onlyOwner {\n        baseTokenUri = _uri;\n    }\n\n    function withdraw() external onlyOwner {\n        msg.sender.transfer(address(this).balance);\n    }\n\n    function setMintPrice(uint256 _price) external onlyOwner {\n        mintPrice = _price;\n    }\n\n    function baseTokenURI() public view returns (string memory) {\n        return baseTokenUri;\n    }\n\n}\n',
  sourcePath: "/home/scarullo/Development/cryptopixel-ethereum/contracts/PixelChainCore.sol",
  ast: {
    absolutePath: "/home/scarullo/Development/cryptopixel-ethereum/contracts/PixelChainCore.sol",
    exportedSymbols: {
      PixelChainCore: [304],
    },
    id: 305,
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 58,
        literals: ["solidity", "^", "0.5", ".0"],
        nodeType: "PragmaDirective",
        src: "0:23:1",
      },
      {
        absolutePath: "@openzeppelin/contracts/ownership/Ownable.sol",
        file: "@openzeppelin/contracts/ownership/Ownable.sol",
        id: 59,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 1071,
        src: "25:55:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "@openzeppelin/contracts/token/ERC721/ERC721Full.sol",
        file: "@openzeppelin/contracts/token/ERC721/ERC721Full.sol",
        id: 60,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 2106,
        src: "81:61:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "/home/scarullo/Development/cryptopixel-ethereum/contracts/Strings.sol",
        file: "./Strings.sol",
        id: 61,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 628,
        src: "143:23:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        baseContracts: [
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 62,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1070,
              src: "195:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$1070",
                typeString: "contract Ownable",
              },
            },
            id: 63,
            nodeType: "InheritanceSpecifier",
            src: "195:7:1",
          },
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 64,
              name: "ERC721Full",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 2105,
              src: "204:10:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ERC721Full_$2105",
                typeString: "contract ERC721Full",
              },
            },
            id: 65,
            nodeType: "InheritanceSpecifier",
            src: "204:10:1",
          },
        ],
        contractDependencies: [654, 755, 765, 1070, 1741, 2081, 2105, 2278, 2381, 2408, 2431],
        contractKind: "contract",
        documentation: null,
        fullyImplemented: true,
        id: 304,
        linearizedBaseContracts: [304, 2105, 2278, 2431, 2081, 2408, 1741, 2381, 755, 765, 1070, 654],
        name: "PixelChainCore",
        nodeType: "ContractDefinition",
        nodes: [
          {
            anonymous: false,
            documentation: null,
            id: 77,
            name: "PixelChainCreated",
            nodeType: "EventDefinition",
            parameters: {
              id: 76,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 67,
                  indexed: false,
                  name: "id",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "245:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 66,
                    name: "uint",
                    nodeType: "ElementaryTypeName",
                    src: "245:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 69,
                  indexed: false,
                  name: "author",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "254:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 68,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "254:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 71,
                  indexed: false,
                  name: "name",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "270:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 70,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "270:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 73,
                  indexed: false,
                  name: "data",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "283:10:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 72,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "283:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 75,
                  indexed: false,
                  name: "palette",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "295:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 74,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "295:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "244:65:1",
            },
            src: "221:89:1",
          },
          {
            constant: false,
            id: 80,
            name: "name",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "316:33:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 78,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "316:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "506978656c436861696e",
              id: 79,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "337:12:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_b5bce59e9038addef7d0b9715eb5fb104737cb2b3ad7dcbb38a7b5b195033fe7",
                typeString: 'literal_string "PixelChain"',
              },
              value: "PixelChain",
            },
            visibility: "public",
          },
          {
            constant: false,
            id: 83,
            name: "symbol",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "355:28:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 81,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "355:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "505843",
              id: 82,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "378:5:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_808f09285addc8fe11b7f430201017ee75a940306d84cfd56f3a3f7630e1ec4b",
                typeString: 'literal_string "PXC"',
              },
              value: "PXC",
            },
            visibility: "public",
          },
          {
            constant: false,
            id: 86,
            name: "baseTokenUri",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "389:24:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 84,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "389:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "",
              id: 85,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "411:2:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                typeString: 'literal_string ""',
              },
              value: "",
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 89,
            name: "mintPrice",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "419:21:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256",
            },
            typeName: {
              id: 87,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "419:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "30",
              id: 88,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "number",
              lValueRequested: false,
              nodeType: "Literal",
              src: "439:1:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_rational_0_by_1",
                typeString: "int_const 0",
              },
              value: "0",
            },
            visibility: "internal",
          },
          {
            canonicalName: "PixelChainCore.PixelChain",
            id: 100,
            members: [
              {
                constant: false,
                id: 91,
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "475:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 90,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "475:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 93,
                name: "data",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "496:10:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 92,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "496:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 95,
                name: "palette",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "516:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 94,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "516:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 97,
                name: "author",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "539:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
                typeName: {
                  id: 96,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "539:7:1",
                  stateMutability: "nonpayable",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 99,
                name: "date",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "563:12:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
                typeName: {
                  id: 98,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "563:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                },
                value: null,
                visibility: "internal",
              },
            ],
            name: "PixelChain",
            nodeType: "StructDefinition",
            scope: 304,
            src: "447:135:1",
            visibility: "public",
          },
          {
            constant: false,
            id: 103,
            name: "pixelChains",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "588:31:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
              typeString: "struct PixelChainCore.PixelChain[]",
            },
            typeName: {
              baseType: {
                contractScope: null,
                id: 101,
                name: "PixelChain",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 100,
                src: "588:10:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PixelChain_$100_storage_ptr",
                  typeString: "struct PixelChainCore.PixelChain",
                },
              },
              id: 102,
              length: null,
              nodeType: "ArrayTypeName",
              src: "588:12:1",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage_ptr",
                typeString: "struct PixelChainCore.PixelChain[]",
              },
            },
            value: null,
            visibility: "public",
          },
          {
            body: {
              id: 110,
              nodeType: "Block",
              src: "672:3:1",
              statements: [],
            },
            documentation: null,
            id: 111,
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    argumentTypes: null,
                    id: 106,
                    name: "name",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 80,
                    src: "651:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  {
                    argumentTypes: null,
                    id: 107,
                    name: "symbol",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 83,
                    src: "657:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                ],
                id: 108,
                modifierName: {
                  argumentTypes: null,
                  id: 105,
                  name: "ERC721Full",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 2105,
                  src: "640:10:1",
                  typeDescriptions: {
                    typeIdentifier: "t_type$_t_contract$_ERC721Full_$2105_$",
                    typeString: "type(contract ERC721Full)",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "640:24:1",
              },
            ],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 104,
              nodeType: "ParameterList",
              parameters: [],
              src: "637:2:1",
            },
            returnParameters: {
              id: 109,
              nodeType: "ParameterList",
              parameters: [],
              src: "672:0:1",
            },
            scope: 304,
            src: "626:49:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 128,
              nodeType: "Block",
              src: "755:119:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [],
                        expression: {
                          argumentTypes: [],
                          id: 120,
                          name: "baseTokenURI",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 303,
                          src: "803:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$__$returns$_t_string_memory_ptr_$",
                            typeString: "function () view returns (string memory)",
                          },
                        },
                        id: 121,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "803:14:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 124,
                            name: "_tokenId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 113,
                            src: "848:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          ],
                          expression: {
                            argumentTypes: null,
                            id: 122,
                            name: "Strings",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 627,
                            src: "831:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_Strings_$627_$",
                              typeString: "type(library Strings)",
                            },
                          },
                          id: 123,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "uint2str",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 626,
                          src: "831:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_uint256_$returns$_t_string_memory_ptr_$",
                            typeString: "function (uint256) pure returns (string memory)",
                          },
                        },
                        id: 125,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "831:26:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      ],
                      expression: {
                        argumentTypes: null,
                        id: 118,
                        name: "Strings",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 627,
                        src: "772:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Strings_$627_$",
                          typeString: "type(library Strings)",
                        },
                      },
                      id: 119,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "strConcat",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 551,
                      src: "772:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_pure$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$_t_string_memory_ptr_$",
                        typeString: "function (string memory,string memory) pure returns (string memory)",
                      },
                    },
                    id: 126,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "772:95:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  functionReturnParameters: 117,
                  id: 127,
                  nodeType: "Return",
                  src: "765:102:1",
                },
              ],
            },
            documentation: null,
            id: 129,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "tokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 114,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 113,
                  name: "_tokenId",
                  nodeType: "VariableDeclaration",
                  scope: 129,
                  src: "699:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 112,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "699:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "698:18:1",
            },
            returnParameters: {
              id: 117,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 116,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 129,
                  src: "740:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 115,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "740:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "739:15:1",
            },
            scope: 304,
            src: "681:193:1",
            stateMutability: "view",
            superFunction: 2208,
            visibility: "external",
          },
          {
            body: {
              id: 215,
              nodeType: "Block",
              src: "1016:588:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 144,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 141,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2537,
                            src: "1034:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg",
                            },
                          },
                          id: 142,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1034:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: ">=",
                        rightExpression: {
                          argumentTypes: null,
                          id: 143,
                          name: "mintPrice",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89,
                          src: "1047:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        src: "1034:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "4e6f7420656e6f75676820657468657220746f206d696e74207468697320746f6b656e21",
                        id: 145,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1058:38:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                        value: "Not enough ether to mint this token!",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                      ],
                      id: 140,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1026:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 146,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1026:71:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 147,
                  nodeType: "ExpressionStatement",
                  src: "1026:71:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 152,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 149,
                            name: "_data",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 133,
                            src: "1115:5:1",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory",
                            },
                          },
                          id: 150,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "length",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1115:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "31303234",
                          id: 151,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1131:4:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1024_by_1",
                            typeString: "int_const 1024",
                          },
                          value: "1024",
                        },
                        src: "1115:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "5468652062797465206172726179206c656e6774682073686f756c64206265206f6620313032342e",
                        id: 153,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1137:42:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_787eed66aff4daae308f98170a7f2700e1f217adc8f18f4ead2ca2f477802c3b",
                          typeString: 'literal_string "The byte array length should be of 1024."',
                        },
                        value: "The byte array length should be of 1024.",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_787eed66aff4daae308f98170a7f2700e1f217adc8f18f4ead2ca2f477802c3b",
                          typeString: 'literal_string "The byte array length should be of 1024."',
                        },
                      ],
                      id: 148,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1107:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 154,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1107:73:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 155,
                  nodeType: "ExpressionStatement",
                  src: "1107:73:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 160,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 157,
                            name: "_palette",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 135,
                            src: "1198:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory",
                            },
                          },
                          id: 158,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "length",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1198:15:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "3438",
                          id: 159,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1217:2:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_48_by_1",
                            typeString: "int_const 48",
                          },
                          value: "48",
                        },
                        src: "1198:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "5468652070616c65747465206172726179206c656e6774682073686f756c64206265206f662034382e",
                        id: 161,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1221:43:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_dcbb63d62bc55c870fc33e96c84506153b00a4d71afdb7d50f97de8ef76a68bd",
                          typeString: 'literal_string "The palette array length should be of 48."',
                        },
                        value: "The palette array length should be of 48.",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_dcbb63d62bc55c870fc33e96c84506153b00a4d71afdb7d50f97de8ef76a68bd",
                          typeString: 'literal_string "The palette array length should be of 48."',
                        },
                      ],
                      id: 156,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1190:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 162,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1190:75:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 163,
                  nodeType: "ExpressionStatement",
                  src: "1190:75:1",
                },
                {
                  condition: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 167,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      expression: {
                        argumentTypes: null,
                        id: 164,
                        name: "msg",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 2537,
                        src: "1280:3:1",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_message",
                          typeString: "msg",
                        },
                      },
                      id: 165,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "value",
                      nodeType: "MemberAccess",
                      referencedDeclaration: null,
                      src: "1280:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      argumentTypes: null,
                      id: 166,
                      name: "mintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "1292:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1280:21:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  falseBody: null,
                  id: 180,
                  nodeType: "IfStatement",
                  src: "1276:94:1",
                  trueBody: {
                    id: 179,
                    nodeType: "Block",
                    src: "1303:67:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                              id: 176,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                argumentTypes: null,
                                expression: {
                                  argumentTypes: null,
                                  id: 173,
                                  name: "msg",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 2537,
                                  src: "1337:3:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_magic_message",
                                    typeString: "msg",
                                  },
                                },
                                id: 174,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "value",
                                nodeType: "MemberAccess",
                                referencedDeclaration: null,
                                src: "1337:9:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256",
                                },
                              },
                              nodeType: "BinaryOperation",
                              operator: "-",
                              rightExpression: {
                                argumentTypes: null,
                                id: 175,
                                name: "mintPrice",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89,
                                src: "1349:9:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256",
                                },
                              },
                              src: "1337:21:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            ],
                            expression: {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 168,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2537,
                                src: "1317:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg",
                                },
                              },
                              id: 171,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1317:10:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                            },
                            id: 172,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "transfer",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "1317:19:1",
                            typeDescriptions: {
                              typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                              typeString: "function (uint256)",
                            },
                          },
                          id: 177,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1317:42:1",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()",
                          },
                        },
                        id: 178,
                        nodeType: "ExpressionStatement",
                        src: "1317:42:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [182],
                  declarations: [
                    {
                      constant: false,
                      id: 182,
                      name: "id",
                      nodeType: "VariableDeclaration",
                      scope: 215,
                      src: "1380:7:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 181,
                        name: "uint",
                        nodeType: "ElementaryTypeName",
                        src: "1380:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      value: null,
                      visibility: "internal",
                    },
                  ],
                  id: 197,
                  initialValue: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 196,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 186,
                              name: "_name",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 131,
                              src: "1418:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              id: 187,
                              name: "_data",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 133,
                              src: "1425:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              id: 188,
                              name: "_palette",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 135,
                              src: "1432:8:1",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 189,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2537,
                                src: "1442:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg",
                                },
                              },
                              id: 190,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1442:10:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 191,
                                name: "block",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2527,
                                src: "1454:5:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_block",
                                  typeString: "block",
                                },
                              },
                              id: 192,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "timestamp",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1454:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                              {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            ],
                            id: 185,
                            name: "PixelChain",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 100,
                            src: "1407:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_PixelChain_$100_storage_ptr_$",
                              typeString: "type(struct PixelChainCore.PixelChain storage pointer)",
                            },
                          },
                          id: 193,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "structConstructorCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1407:63:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_memory",
                            typeString: "struct PixelChainCore.PixelChain memory",
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_struct$_PixelChain_$100_memory",
                            typeString: "struct PixelChainCore.PixelChain memory",
                          },
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 183,
                          name: "pixelChains",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 103,
                          src: "1390:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                          },
                        },
                        id: 184,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "push",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1390:16:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_arraypush_nonpayable$_t_struct$_PixelChain_$100_storage_$returns$_t_uint256_$",
                          typeString: "function (struct PixelChainCore.PixelChain storage ref) returns (uint256)",
                        },
                      },
                      id: 194,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1390:81:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 195,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1474:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1",
                      },
                      value: "1",
                    },
                    src: "1390:85:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1380:95:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 199,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "1491:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 200,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1491:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 201,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 182,
                        src: "1503:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 198,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [1888],
                      referencedDeclaration: 1888,
                      src: "1485:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)",
                      },
                    },
                    id: 202,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1485:21:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 203,
                  nodeType: "ExpressionStatement",
                  src: "1485:21:1",
                },
                {
                  eventCall: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 205,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 182,
                        src: "1539:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 206,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "1543:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 207,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1543:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 208,
                        name: "_name",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 131,
                        src: "1555:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 209,
                        name: "_data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 133,
                        src: "1562:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 210,
                        name: "_palette",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 135,
                        src: "1569:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      ],
                      id: 204,
                      name: "PixelChainCreated",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 77,
                      src: "1521:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$_t_address_$_t_string_memory_ptr_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$returns$__$",
                        typeString: "function (uint256,address,string memory,bytes memory,bytes memory)",
                      },
                    },
                    id: 211,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1521:57:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 212,
                  nodeType: "EmitStatement",
                  src: "1516:62:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 213,
                    name: "id",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 182,
                    src: "1595:2:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  functionReturnParameters: 139,
                  id: 214,
                  nodeType: "Return",
                  src: "1588:9:1",
                },
              ],
            },
            documentation: null,
            id: 216,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "create",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 136,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 131,
                  name: "_name",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "922:19:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 130,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "922:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 133,
                  name: "_data",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "943:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 132,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "943:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 135,
                  name: "_palette",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "963:21:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 134,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "963:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "921:64:1",
            },
            returnParameters: {
              id: 139,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 138,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "1010:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 137,
                    name: "uint",
                    nodeType: "ElementaryTypeName",
                    src: "1010:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1009:6:1",
            },
            scope: 304,
            src: "906:698:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 253,
              nodeType: "Block",
              src: "1724:144:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 231,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1742:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 233,
                          indexExpression: {
                            argumentTypes: null,
                            id: 232,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1754:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1742:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 234,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "name",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 91,
                        src: "1742:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage",
                          typeString: "string storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 235,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1765:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 237,
                          indexExpression: {
                            argumentTypes: null,
                            id: 236,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1777:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1765:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 238,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 93,
                        src: "1765:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 239,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1788:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 241,
                          indexExpression: {
                            argumentTypes: null,
                            id: 240,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1800:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1788:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 242,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "palette",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 95,
                        src: "1788:24:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 243,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1814:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 245,
                          indexExpression: {
                            argumentTypes: null,
                            id: 244,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1826:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1814:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 246,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "author",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 97,
                        src: "1814:23:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 247,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1839:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 249,
                          indexExpression: {
                            argumentTypes: null,
                            id: 248,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1851:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1839:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 250,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "date",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 99,
                        src: "1839:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    id: 251,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "1741:120:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_string_storage_$_t_bytes_storage_$_t_bytes_storage_$_t_address_$_t_uint256_$",
                      typeString: "tuple(string storage ref,bytes storage ref,bytes storage ref,address,uint256)",
                    },
                  },
                  functionReturnParameters: 230,
                  id: 252,
                  nodeType: "Return",
                  src: "1734:127:1",
                },
              ],
            },
            documentation: null,
            id: 254,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieve",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 219,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 218,
                  name: "_id",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1628:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 217,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1628:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1627:13:1",
            },
            returnParameters: {
              id: 230,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 221,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1663:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 220,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1663:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 223,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1678:12:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 222,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "1678:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 225,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1692:12:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 224,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "1692:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 227,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1706:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 226,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1706:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 229,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1715:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 228,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1715:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1662:61:1",
            },
            scope: 304,
            src: "1610:258:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 265,
              nodeType: "Block",
              src: "1936:36:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 263,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 261,
                      name: "baseTokenUri",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 86,
                      src: "1946:12:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_storage",
                        typeString: "string storage ref",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 262,
                      name: "_uri",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 256,
                      src: "1961:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string memory",
                      },
                    },
                    src: "1946:19:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  id: 264,
                  nodeType: "ExpressionStatement",
                  src: "1946:19:1",
                },
              ],
            },
            documentation: null,
            id: 266,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 259,
                modifierName: {
                  argumentTypes: null,
                  id: 258,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "1926:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "1926:9:1",
              },
            ],
            name: "setBaseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 257,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 256,
                  name: "_uri",
                  nodeType: "VariableDeclaration",
                  scope: 266,
                  src: "1899:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 255,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1899:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1898:20:1",
            },
            returnParameters: {
              id: 260,
              nodeType: "ParameterList",
              parameters: [],
              src: "1936:0:1",
            },
            scope: 304,
            src: "1874:98:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 282,
              nodeType: "Block",
              src: "2017:59:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 277,
                              name: "this",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2585,
                              src: "2055:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_PixelChainCore_$304",
                                typeString: "contract PixelChainCore",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_PixelChainCore_$304",
                                typeString: "contract PixelChainCore",
                              },
                            ],
                            id: 276,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "2047:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)",
                            },
                            typeName: "address",
                          },
                          id: 278,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "2047:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        id: 279,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "balance",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "2047:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      expression: {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 271,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "2027:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 274,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "2027:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      id: 275,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: null,
                      src: "2027:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)",
                      },
                    },
                    id: 280,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2027:42:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 281,
                  nodeType: "ExpressionStatement",
                  src: "2027:42:1",
                },
              ],
            },
            documentation: null,
            id: 283,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 269,
                modifierName: {
                  argumentTypes: null,
                  id: 268,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "2007:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2007:9:1",
              },
            ],
            name: "withdraw",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 267,
              nodeType: "ParameterList",
              parameters: [],
              src: "1995:2:1",
            },
            returnParameters: {
              id: 270,
              nodeType: "ParameterList",
              parameters: [],
              src: "2017:0:1",
            },
            scope: 304,
            src: "1978:98:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "external",
          },
          {
            body: {
              id: 294,
              nodeType: "Block",
              src: "2139:35:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 292,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 290,
                      name: "mintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "2149:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 291,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 285,
                      src: "2161:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2149:18:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 293,
                  nodeType: "ExpressionStatement",
                  src: "2149:18:1",
                },
              ],
            },
            documentation: null,
            id: 295,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 288,
                modifierName: {
                  argumentTypes: null,
                  id: 287,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "2129:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2129:9:1",
              },
            ],
            name: "setMintPrice",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 286,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 285,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 295,
                  src: "2104:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 284,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2104:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "2103:16:1",
            },
            returnParameters: {
              id: 289,
              nodeType: "ParameterList",
              parameters: [],
              src: "2139:0:1",
            },
            scope: 304,
            src: "2082:92:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "external",
          },
          {
            body: {
              id: 302,
              nodeType: "Block",
              src: "2240:36:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 300,
                    name: "baseTokenUri",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 86,
                    src: "2257:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  functionReturnParameters: 299,
                  id: 301,
                  nodeType: "Return",
                  src: "2250:19:1",
                },
              ],
            },
            documentation: null,
            id: 303,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "baseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 296,
              nodeType: "ParameterList",
              parameters: [],
              src: "2201:2:1",
            },
            returnParameters: {
              id: 299,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 298,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 303,
                  src: "2225:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 297,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "2225:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "2224:15:1",
            },
            scope: 304,
            src: "2180:96:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public",
          },
        ],
        scope: 305,
        src: "168:2111:1",
      },
    ],
    src: "0:2280:1",
  },
  legacyAST: {
    absolutePath: "/home/scarullo/Development/cryptopixel-ethereum/contracts/PixelChainCore.sol",
    exportedSymbols: {
      PixelChainCore: [304],
    },
    id: 305,
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 58,
        literals: ["solidity", "^", "0.5", ".0"],
        nodeType: "PragmaDirective",
        src: "0:23:1",
      },
      {
        absolutePath: "@openzeppelin/contracts/ownership/Ownable.sol",
        file: "@openzeppelin/contracts/ownership/Ownable.sol",
        id: 59,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 1071,
        src: "25:55:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "@openzeppelin/contracts/token/ERC721/ERC721Full.sol",
        file: "@openzeppelin/contracts/token/ERC721/ERC721Full.sol",
        id: 60,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 2106,
        src: "81:61:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        absolutePath: "/home/scarullo/Development/cryptopixel-ethereum/contracts/Strings.sol",
        file: "./Strings.sol",
        id: 61,
        nodeType: "ImportDirective",
        scope: 305,
        sourceUnit: 628,
        src: "143:23:1",
        symbolAliases: [],
        unitAlias: "",
      },
      {
        baseContracts: [
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 62,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1070,
              src: "195:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$1070",
                typeString: "contract Ownable",
              },
            },
            id: 63,
            nodeType: "InheritanceSpecifier",
            src: "195:7:1",
          },
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 64,
              name: "ERC721Full",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 2105,
              src: "204:10:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ERC721Full_$2105",
                typeString: "contract ERC721Full",
              },
            },
            id: 65,
            nodeType: "InheritanceSpecifier",
            src: "204:10:1",
          },
        ],
        contractDependencies: [654, 755, 765, 1070, 1741, 2081, 2105, 2278, 2381, 2408, 2431],
        contractKind: "contract",
        documentation: null,
        fullyImplemented: true,
        id: 304,
        linearizedBaseContracts: [304, 2105, 2278, 2431, 2081, 2408, 1741, 2381, 755, 765, 1070, 654],
        name: "PixelChainCore",
        nodeType: "ContractDefinition",
        nodes: [
          {
            anonymous: false,
            documentation: null,
            id: 77,
            name: "PixelChainCreated",
            nodeType: "EventDefinition",
            parameters: {
              id: 76,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 67,
                  indexed: false,
                  name: "id",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "245:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 66,
                    name: "uint",
                    nodeType: "ElementaryTypeName",
                    src: "245:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 69,
                  indexed: false,
                  name: "author",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "254:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 68,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "254:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 71,
                  indexed: false,
                  name: "name",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "270:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 70,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "270:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 73,
                  indexed: false,
                  name: "data",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "283:10:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 72,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "283:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 75,
                  indexed: false,
                  name: "palette",
                  nodeType: "VariableDeclaration",
                  scope: 77,
                  src: "295:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 74,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "295:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "244:65:1",
            },
            src: "221:89:1",
          },
          {
            constant: false,
            id: 80,
            name: "name",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "316:33:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 78,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "316:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "506978656c436861696e",
              id: 79,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "337:12:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_b5bce59e9038addef7d0b9715eb5fb104737cb2b3ad7dcbb38a7b5b195033fe7",
                typeString: 'literal_string "PixelChain"',
              },
              value: "PixelChain",
            },
            visibility: "public",
          },
          {
            constant: false,
            id: 83,
            name: "symbol",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "355:28:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 81,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "355:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "505843",
              id: 82,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "378:5:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_808f09285addc8fe11b7f430201017ee75a940306d84cfd56f3a3f7630e1ec4b",
                typeString: 'literal_string "PXC"',
              },
              value: "PXC",
            },
            visibility: "public",
          },
          {
            constant: false,
            id: 86,
            name: "baseTokenUri",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "389:24:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_string_storage",
              typeString: "string",
            },
            typeName: {
              id: 84,
              name: "string",
              nodeType: "ElementaryTypeName",
              src: "389:6:1",
              typeDescriptions: {
                typeIdentifier: "t_string_storage_ptr",
                typeString: "string",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "",
              id: 85,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "string",
              lValueRequested: false,
              nodeType: "Literal",
              src: "411:2:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                typeString: 'literal_string ""',
              },
              value: "",
            },
            visibility: "internal",
          },
          {
            constant: false,
            id: 89,
            name: "mintPrice",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "419:21:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256",
            },
            typeName: {
              id: 87,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "419:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256",
              },
            },
            value: {
              argumentTypes: null,
              hexValue: "30",
              id: 88,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "number",
              lValueRequested: false,
              nodeType: "Literal",
              src: "439:1:1",
              subdenomination: null,
              typeDescriptions: {
                typeIdentifier: "t_rational_0_by_1",
                typeString: "int_const 0",
              },
              value: "0",
            },
            visibility: "internal",
          },
          {
            canonicalName: "PixelChainCore.PixelChain",
            id: 100,
            members: [
              {
                constant: false,
                id: 91,
                name: "name",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "475:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_string_storage_ptr",
                  typeString: "string",
                },
                typeName: {
                  id: 90,
                  name: "string",
                  nodeType: "ElementaryTypeName",
                  src: "475:6:1",
                  typeDescriptions: {
                    typeIdentifier: "t_string_storage_ptr",
                    typeString: "string",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 93,
                name: "data",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "496:10:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 92,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "496:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 95,
                name: "palette",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "516:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bytes_storage_ptr",
                  typeString: "bytes",
                },
                typeName: {
                  id: 94,
                  name: "bytes",
                  nodeType: "ElementaryTypeName",
                  src: "516:5:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_storage_ptr",
                    typeString: "bytes",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 97,
                name: "author",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "539:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address",
                },
                typeName: {
                  id: 96,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "539:7:1",
                  stateMutability: "nonpayable",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                },
                value: null,
                visibility: "internal",
              },
              {
                constant: false,
                id: 99,
                name: "date",
                nodeType: "VariableDeclaration",
                scope: 100,
                src: "563:12:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256",
                },
                typeName: {
                  id: 98,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "563:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                },
                value: null,
                visibility: "internal",
              },
            ],
            name: "PixelChain",
            nodeType: "StructDefinition",
            scope: 304,
            src: "447:135:1",
            visibility: "public",
          },
          {
            constant: false,
            id: 103,
            name: "pixelChains",
            nodeType: "VariableDeclaration",
            scope: 304,
            src: "588:31:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
              typeString: "struct PixelChainCore.PixelChain[]",
            },
            typeName: {
              baseType: {
                contractScope: null,
                id: 101,
                name: "PixelChain",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 100,
                src: "588:10:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PixelChain_$100_storage_ptr",
                  typeString: "struct PixelChainCore.PixelChain",
                },
              },
              id: 102,
              length: null,
              nodeType: "ArrayTypeName",
              src: "588:12:1",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage_ptr",
                typeString: "struct PixelChainCore.PixelChain[]",
              },
            },
            value: null,
            visibility: "public",
          },
          {
            body: {
              id: 110,
              nodeType: "Block",
              src: "672:3:1",
              statements: [],
            },
            documentation: null,
            id: 111,
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    argumentTypes: null,
                    id: 106,
                    name: "name",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 80,
                    src: "651:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  {
                    argumentTypes: null,
                    id: 107,
                    name: "symbol",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 83,
                    src: "657:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                ],
                id: 108,
                modifierName: {
                  argumentTypes: null,
                  id: 105,
                  name: "ERC721Full",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 2105,
                  src: "640:10:1",
                  typeDescriptions: {
                    typeIdentifier: "t_type$_t_contract$_ERC721Full_$2105_$",
                    typeString: "type(contract ERC721Full)",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "640:24:1",
              },
            ],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 104,
              nodeType: "ParameterList",
              parameters: [],
              src: "637:2:1",
            },
            returnParameters: {
              id: 109,
              nodeType: "ParameterList",
              parameters: [],
              src: "672:0:1",
            },
            scope: 304,
            src: "626:49:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 128,
              nodeType: "Block",
              src: "755:119:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [],
                        expression: {
                          argumentTypes: [],
                          id: 120,
                          name: "baseTokenURI",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 303,
                          src: "803:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$__$returns$_t_string_memory_ptr_$",
                            typeString: "function () view returns (string memory)",
                          },
                        },
                        id: 121,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "803:14:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 124,
                            name: "_tokenId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 113,
                            src: "848:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          ],
                          expression: {
                            argumentTypes: null,
                            id: 122,
                            name: "Strings",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 627,
                            src: "831:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_Strings_$627_$",
                              typeString: "type(library Strings)",
                            },
                          },
                          id: 123,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "uint2str",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 626,
                          src: "831:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_uint256_$returns$_t_string_memory_ptr_$",
                            typeString: "function (uint256) pure returns (string memory)",
                          },
                        },
                        id: 125,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "831:26:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      ],
                      expression: {
                        argumentTypes: null,
                        id: 118,
                        name: "Strings",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 627,
                        src: "772:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Strings_$627_$",
                          typeString: "type(library Strings)",
                        },
                      },
                      id: 119,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "strConcat",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 551,
                      src: "772:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_pure$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$_t_string_memory_ptr_$",
                        typeString: "function (string memory,string memory) pure returns (string memory)",
                      },
                    },
                    id: 126,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "772:95:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory",
                    },
                  },
                  functionReturnParameters: 117,
                  id: 127,
                  nodeType: "Return",
                  src: "765:102:1",
                },
              ],
            },
            documentation: null,
            id: 129,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "tokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 114,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 113,
                  name: "_tokenId",
                  nodeType: "VariableDeclaration",
                  scope: 129,
                  src: "699:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 112,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "699:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "698:18:1",
            },
            returnParameters: {
              id: 117,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 116,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 129,
                  src: "740:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 115,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "740:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "739:15:1",
            },
            scope: 304,
            src: "681:193:1",
            stateMutability: "view",
            superFunction: 2208,
            visibility: "external",
          },
          {
            body: {
              id: 215,
              nodeType: "Block",
              src: "1016:588:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 144,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 141,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2537,
                            src: "1034:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg",
                            },
                          },
                          id: 142,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1034:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: ">=",
                        rightExpression: {
                          argumentTypes: null,
                          id: 143,
                          name: "mintPrice",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89,
                          src: "1047:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        src: "1034:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "4e6f7420656e6f75676820657468657220746f206d696e74207468697320746f6b656e21",
                        id: 145,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1058:38:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                        value: "Not enough ether to mint this token!",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_5cc1ea7b41baba2830a0144b887859697e72143b45df99af3b4f14a94ae2ae4f",
                          typeString: 'literal_string "Not enough ether to mint this token!"',
                        },
                      ],
                      id: 140,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1026:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 146,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1026:71:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 147,
                  nodeType: "ExpressionStatement",
                  src: "1026:71:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 152,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 149,
                            name: "_data",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 133,
                            src: "1115:5:1",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory",
                            },
                          },
                          id: 150,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "length",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1115:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "31303234",
                          id: 151,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1131:4:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1024_by_1",
                            typeString: "int_const 1024",
                          },
                          value: "1024",
                        },
                        src: "1115:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "5468652062797465206172726179206c656e6774682073686f756c64206265206f6620313032342e",
                        id: 153,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1137:42:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_787eed66aff4daae308f98170a7f2700e1f217adc8f18f4ead2ca2f477802c3b",
                          typeString: 'literal_string "The byte array length should be of 1024."',
                        },
                        value: "The byte array length should be of 1024.",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_787eed66aff4daae308f98170a7f2700e1f217adc8f18f4ead2ca2f477802c3b",
                          typeString: 'literal_string "The byte array length should be of 1024."',
                        },
                      ],
                      id: 148,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1107:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 154,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1107:73:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 155,
                  nodeType: "ExpressionStatement",
                  src: "1107:73:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        id: 160,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 157,
                            name: "_palette",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 135,
                            src: "1198:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory",
                            },
                          },
                          id: 158,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "length",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1198:15:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256",
                          },
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "3438",
                          id: 159,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1217:2:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_48_by_1",
                            typeString: "int_const 48",
                          },
                          value: "48",
                        },
                        src: "1198:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                      },
                      {
                        argumentTypes: null,
                        hexValue: "5468652070616c65747465206172726179206c656e6774682073686f756c64206265206f662034382e",
                        id: 161,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1221:43:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_dcbb63d62bc55c870fc33e96c84506153b00a4d71afdb7d50f97de8ef76a68bd",
                          typeString: 'literal_string "The palette array length should be of 48."',
                        },
                        value: "The palette array length should be of 48.",
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool",
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_dcbb63d62bc55c870fc33e96c84506153b00a4d71afdb7d50f97de8ef76a68bd",
                          typeString: 'literal_string "The palette array length should be of 48."',
                        },
                      ],
                      id: 156,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2540, 2541],
                      referencedDeclaration: 2541,
                      src: "1190:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure",
                      },
                    },
                    id: 162,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1190:75:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 163,
                  nodeType: "ExpressionStatement",
                  src: "1190:75:1",
                },
                {
                  condition: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 167,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      expression: {
                        argumentTypes: null,
                        id: 164,
                        name: "msg",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 2537,
                        src: "1280:3:1",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_message",
                          typeString: "msg",
                        },
                      },
                      id: 165,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "value",
                      nodeType: "MemberAccess",
                      referencedDeclaration: null,
                      src: "1280:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      argumentTypes: null,
                      id: 166,
                      name: "mintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "1292:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "1280:21:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool",
                    },
                  },
                  falseBody: null,
                  id: 180,
                  nodeType: "IfStatement",
                  src: "1276:94:1",
                  trueBody: {
                    id: 179,
                    nodeType: "Block",
                    src: "1303:67:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                              id: 176,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                argumentTypes: null,
                                expression: {
                                  argumentTypes: null,
                                  id: 173,
                                  name: "msg",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 2537,
                                  src: "1337:3:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_magic_message",
                                    typeString: "msg",
                                  },
                                },
                                id: 174,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "value",
                                nodeType: "MemberAccess",
                                referencedDeclaration: null,
                                src: "1337:9:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256",
                                },
                              },
                              nodeType: "BinaryOperation",
                              operator: "-",
                              rightExpression: {
                                argumentTypes: null,
                                id: 175,
                                name: "mintPrice",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89,
                                src: "1349:9:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256",
                                },
                              },
                              src: "1337:21:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            ],
                            expression: {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 168,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2537,
                                src: "1317:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg",
                                },
                              },
                              id: 171,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1317:10:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                            },
                            id: 172,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "transfer",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "1317:19:1",
                            typeDescriptions: {
                              typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                              typeString: "function (uint256)",
                            },
                          },
                          id: 177,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1317:42:1",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()",
                          },
                        },
                        id: 178,
                        nodeType: "ExpressionStatement",
                        src: "1317:42:1",
                      },
                    ],
                  },
                },
                {
                  assignments: [182],
                  declarations: [
                    {
                      constant: false,
                      id: 182,
                      name: "id",
                      nodeType: "VariableDeclaration",
                      scope: 215,
                      src: "1380:7:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                      typeName: {
                        id: 181,
                        name: "uint",
                        nodeType: "ElementaryTypeName",
                        src: "1380:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      value: null,
                      visibility: "internal",
                    },
                  ],
                  id: 197,
                  initialValue: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                    id: 196,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 186,
                              name: "_name",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 131,
                              src: "1418:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              id: 187,
                              name: "_data",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 133,
                              src: "1425:5:1",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              id: 188,
                              name: "_palette",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 135,
                              src: "1432:8:1",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 189,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2537,
                                src: "1442:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg",
                                },
                              },
                              id: 190,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1442:10:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 191,
                                name: "block",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 2527,
                                src: "1454:5:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_block",
                                  typeString: "block",
                                },
                              },
                              id: 192,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "timestamp",
                              nodeType: "MemberAccess",
                              referencedDeclaration: null,
                              src: "1454:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_string_memory_ptr",
                                typeString: "string memory",
                              },
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory",
                              },
                              {
                                typeIdentifier: "t_address_payable",
                                typeString: "address payable",
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256",
                              },
                            ],
                            id: 185,
                            name: "PixelChain",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 100,
                            src: "1407:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_PixelChain_$100_storage_ptr_$",
                              typeString: "type(struct PixelChainCore.PixelChain storage pointer)",
                            },
                          },
                          id: 193,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "structConstructorCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1407:63:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_memory",
                            typeString: "struct PixelChainCore.PixelChain memory",
                          },
                        },
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_struct$_PixelChain_$100_memory",
                            typeString: "struct PixelChainCore.PixelChain memory",
                          },
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 183,
                          name: "pixelChains",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 103,
                          src: "1390:11:1",
                          typeDescriptions: {
                            typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                          },
                        },
                        id: 184,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "push",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1390:16:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_arraypush_nonpayable$_t_struct$_PixelChain_$100_storage_$returns$_t_uint256_$",
                          typeString: "function (struct PixelChainCore.PixelChain storage ref) returns (uint256)",
                        },
                      },
                      id: 194,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1390:81:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 195,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1474:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1",
                      },
                      value: "1",
                    },
                    src: "1390:85:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1380:95:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 199,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "1491:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 200,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1491:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 201,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 182,
                        src: "1503:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      id: 198,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [1888],
                      referencedDeclaration: 1888,
                      src: "1485:5:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)",
                      },
                    },
                    id: 202,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1485:21:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 203,
                  nodeType: "ExpressionStatement",
                  src: "1485:21:1",
                },
                {
                  eventCall: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 205,
                        name: "id",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 182,
                        src: "1539:2:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 206,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "1543:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 207,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1543:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 208,
                        name: "_name",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 131,
                        src: "1555:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 209,
                        name: "_data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 133,
                        src: "1562:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                      {
                        argumentTypes: null,
                        id: 210,
                        name: "_palette",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 135,
                        src: "1569:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                        {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory",
                        },
                      ],
                      id: 204,
                      name: "PixelChainCreated",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 77,
                      src: "1521:17:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$_t_address_$_t_string_memory_ptr_$_t_bytes_memory_ptr_$_t_bytes_memory_ptr_$returns$__$",
                        typeString: "function (uint256,address,string memory,bytes memory,bytes memory)",
                      },
                    },
                    id: 211,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1521:57:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 212,
                  nodeType: "EmitStatement",
                  src: "1516:62:1",
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 213,
                    name: "id",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 182,
                    src: "1595:2:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  functionReturnParameters: 139,
                  id: 214,
                  nodeType: "Return",
                  src: "1588:9:1",
                },
              ],
            },
            documentation: null,
            id: 216,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "create",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 136,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 131,
                  name: "_name",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "922:19:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 130,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "922:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 133,
                  name: "_data",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "943:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 132,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "943:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 135,
                  name: "_palette",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "963:21:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 134,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "963:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "921:64:1",
            },
            returnParameters: {
              id: 139,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 138,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 216,
                  src: "1010:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 137,
                    name: "uint",
                    nodeType: "ElementaryTypeName",
                    src: "1010:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1009:6:1",
            },
            scope: 304,
            src: "906:698:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 253,
              nodeType: "Block",
              src: "1724:144:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 231,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1742:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 233,
                          indexExpression: {
                            argumentTypes: null,
                            id: 232,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1754:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1742:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 234,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "name",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 91,
                        src: "1742:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage",
                          typeString: "string storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 235,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1765:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 237,
                          indexExpression: {
                            argumentTypes: null,
                            id: 236,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1777:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1765:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 238,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 93,
                        src: "1765:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 239,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1788:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 241,
                          indexExpression: {
                            argumentTypes: null,
                            id: 240,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1800:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1788:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 242,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "palette",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 95,
                        src: "1788:24:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 243,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1814:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 245,
                          indexExpression: {
                            argumentTypes: null,
                            id: 244,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1826:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1814:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 246,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "author",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 97,
                        src: "1814:23:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address",
                        },
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 247,
                            name: "pixelChains",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 103,
                            src: "1839:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_PixelChain_$100_storage_$dyn_storage",
                              typeString: "struct PixelChainCore.PixelChain storage ref[] storage ref",
                            },
                          },
                          id: 249,
                          indexExpression: {
                            argumentTypes: null,
                            id: 248,
                            name: "_id",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 218,
                            src: "1851:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256",
                            },
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "1839:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PixelChain_$100_storage",
                            typeString: "struct PixelChainCore.PixelChain storage ref",
                          },
                        },
                        id: 250,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "date",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 99,
                        src: "1839:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    id: 251,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "1741:120:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_string_storage_$_t_bytes_storage_$_t_bytes_storage_$_t_address_$_t_uint256_$",
                      typeString: "tuple(string storage ref,bytes storage ref,bytes storage ref,address,uint256)",
                    },
                  },
                  functionReturnParameters: 230,
                  id: 252,
                  nodeType: "Return",
                  src: "1734:127:1",
                },
              ],
            },
            documentation: null,
            id: 254,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "retrieve",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 219,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 218,
                  name: "_id",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1628:11:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 217,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1628:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1627:13:1",
            },
            returnParameters: {
              id: 230,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 221,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1663:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 220,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1663:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 223,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1678:12:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 222,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "1678:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 225,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1692:12:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes",
                  },
                  typeName: {
                    id: 224,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "1692:5:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 227,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1706:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address",
                  },
                  typeName: {
                    id: 226,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1706:7:1",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
                {
                  constant: false,
                  id: 229,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 254,
                  src: "1715:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 228,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1715:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1662:61:1",
            },
            scope: 304,
            src: "1610:258:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 265,
              nodeType: "Block",
              src: "1936:36:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 263,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 261,
                      name: "baseTokenUri",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 86,
                      src: "1946:12:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_storage",
                        typeString: "string storage ref",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 262,
                      name: "_uri",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 256,
                      src: "1961:4:1",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string memory",
                      },
                    },
                    src: "1946:19:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  id: 264,
                  nodeType: "ExpressionStatement",
                  src: "1946:19:1",
                },
              ],
            },
            documentation: null,
            id: 266,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 259,
                modifierName: {
                  argumentTypes: null,
                  id: 258,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "1926:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "1926:9:1",
              },
            ],
            name: "setBaseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 257,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 256,
                  name: "_uri",
                  nodeType: "VariableDeclaration",
                  scope: 266,
                  src: "1899:18:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 255,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "1899:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "1898:20:1",
            },
            returnParameters: {
              id: 260,
              nodeType: "ParameterList",
              parameters: [],
              src: "1936:0:1",
            },
            scope: 304,
            src: "1874:98:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public",
          },
          {
            body: {
              id: 282,
              nodeType: "Block",
              src: "2017:59:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 277,
                              name: "this",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2585,
                              src: "2055:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_PixelChainCore_$304",
                                typeString: "contract PixelChainCore",
                              },
                            },
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_PixelChainCore_$304",
                                typeString: "contract PixelChainCore",
                              },
                            ],
                            id: 276,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "2047:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)",
                            },
                            typeName: "address",
                          },
                          id: 278,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "2047:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address",
                          },
                        },
                        id: 279,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "balance",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "2047:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      },
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256",
                        },
                      ],
                      expression: {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 271,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2537,
                          src: "2027:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg",
                          },
                        },
                        id: 274,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "2027:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address_payable",
                          typeString: "address payable",
                        },
                      },
                      id: 275,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: null,
                      src: "2027:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)",
                      },
                    },
                    id: 280,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2027:42:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()",
                    },
                  },
                  id: 281,
                  nodeType: "ExpressionStatement",
                  src: "2027:42:1",
                },
              ],
            },
            documentation: null,
            id: 283,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 269,
                modifierName: {
                  argumentTypes: null,
                  id: 268,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "2007:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2007:9:1",
              },
            ],
            name: "withdraw",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 267,
              nodeType: "ParameterList",
              parameters: [],
              src: "1995:2:1",
            },
            returnParameters: {
              id: 270,
              nodeType: "ParameterList",
              parameters: [],
              src: "2017:0:1",
            },
            scope: 304,
            src: "1978:98:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "external",
          },
          {
            body: {
              id: 294,
              nodeType: "Block",
              src: "2139:35:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 292,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 290,
                      name: "mintPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89,
                      src: "2149:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 291,
                      name: "_price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 285,
                      src: "2161:6:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256",
                      },
                    },
                    src: "2149:18:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  id: 293,
                  nodeType: "ExpressionStatement",
                  src: "2149:18:1",
                },
              ],
            },
            documentation: null,
            id: 295,
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: null,
                id: 288,
                modifierName: {
                  argumentTypes: null,
                  id: 287,
                  name: "onlyOwner",
                  nodeType: "Identifier",
                  overloadedDeclarations: [],
                  referencedDeclaration: 1003,
                  src: "2129:9:1",
                  typeDescriptions: {
                    typeIdentifier: "t_modifier$__$",
                    typeString: "modifier ()",
                  },
                },
                nodeType: "ModifierInvocation",
                src: "2129:9:1",
              },
            ],
            name: "setMintPrice",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 286,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 285,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 295,
                  src: "2104:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256",
                  },
                  typeName: {
                    id: 284,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2104:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "2103:16:1",
            },
            returnParameters: {
              id: 289,
              nodeType: "ParameterList",
              parameters: [],
              src: "2139:0:1",
            },
            scope: 304,
            src: "2082:92:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "external",
          },
          {
            body: {
              id: 302,
              nodeType: "Block",
              src: "2240:36:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 300,
                    name: "baseTokenUri",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 86,
                    src: "2257:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage",
                      typeString: "string storage ref",
                    },
                  },
                  functionReturnParameters: 299,
                  id: 301,
                  nodeType: "Return",
                  src: "2250:19:1",
                },
              ],
            },
            documentation: null,
            id: 303,
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "baseTokenURI",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 296,
              nodeType: "ParameterList",
              parameters: [],
              src: "2201:2:1",
            },
            returnParameters: {
              id: 299,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 298,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 303,
                  src: "2225:13:1",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string",
                  },
                  typeName: {
                    id: 297,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "2225:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string",
                    },
                  },
                  value: null,
                  visibility: "internal",
                },
              ],
              src: "2224:15:1",
            },
            scope: 304,
            src: "2180:96:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public",
          },
        ],
        scope: 305,
        src: "168:2111:1",
      },
    ],
    src: "0:2280:1",
  },
  compiler: {
    name: "solc",
    version: "0.5.17+commit.d19bba13.Emscripten.clang",
  },
  networks: {
    3: {
      events: {
        "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "approved",
              type: "address",
            },
            {
              indexed: true,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
          signature: "0x8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925",
        },
        "0x17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "operator",
              type: "address",
            },
            {
              indexed: false,
              internalType: "bool",
              name: "approved",
              type: "bool",
            },
          ],
          name: "ApprovalForAll",
          type: "event",
          signature: "0x17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31",
        },
        "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
          signature: "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0",
        },
        "0xe3c991d8b5174c35c840765580a28094540e124a55f521a887399042206e0f8c": {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "id",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "address",
              name: "author",
              type: "address",
            },
            {
              indexed: false,
              internalType: "string",
              name: "name",
              type: "string",
            },
            {
              indexed: false,
              internalType: "bytes",
              name: "data",
              type: "bytes",
            },
            {
              indexed: false,
              internalType: "bytes",
              name: "palette",
              type: "bytes",
            },
          ],
          name: "PixelChainCreated",
          type: "event",
          signature: "0xe3c991d8b5174c35c840765580a28094540e124a55f521a887399042206e0f8c",
        },
        "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef": {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: true,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
          signature: "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
        },
      },
      links: {},
      address: "0xEfe120bFda0C17eb65fCebfe180BBCFC470B0878",
      transactionHash: "0x7504ccb34e2f7868d6713c994a163122b459dc023b3d0f108c16976e44c8668d",
    },
  },
  schemaVersion: "3.0.20",
  updatedAt: "2020-03-30T19:48:31.479Z",
  networkType: "ethereum",
  devdoc: {
    methods: {
      "approve(address,uint256)": {
        details:
          "Approves another address to transfer the given token ID The zero address indicates there is no approved address. There can only be one approved address per token at a given time. Can only be called by the token owner or an approved operator.",
        params: {
          to: "address to be approved for the given token ID",
          tokenId: "uint256 ID of the token to be approved",
        },
      },
      "balanceOf(address)": {
        details: "Gets the balance of the specified address.",
        params: {
          owner: "address to query the balance of",
        },
        return: "uint256 representing the amount owned by the passed address",
      },
      "baseURI()": {
        details:
          "Returns the base URI set via {_setBaseURI}. This will be automatically added as a preffix in {tokenURI} to each token's URI, when they are non-empty.    * _Available since v2.5.0._",
      },
      "getApproved(uint256)": {
        details:
          "Gets the approved address for a token ID, or zero if no address set Reverts if the token ID does not exist.",
        params: {
          tokenId: "uint256 ID of the token to query the approval of",
        },
        return: "address currently approved for the given token ID",
      },
      "isApprovedForAll(address,address)": {
        details: "Tells whether an operator is approved by a given owner.",
        params: {
          operator: "operator address which you want to query the approval of",
          owner: "owner address which you want to query the approval of",
        },
        return: "bool whether the given operator is approved by the given owner",
      },
      "isOwner()": {
        details: "Returns true if the caller is the current owner.",
      },
      "owner()": {
        details: "Returns the address of the current owner.",
      },
      "ownerOf(uint256)": {
        details: "Gets the owner of the specified token ID.",
        params: {
          tokenId: "uint256 ID of the token to query the owner of",
        },
        return: "address currently marked as the owner of the given token ID",
      },
      "renounceOwnership()": {
        details:
          "Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner.     * NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner.",
      },
      "safeTransferFrom(address,address,uint256)": {
        details:
          'Safely transfers the ownership of a given token ID to another address If the target address is a contract, it must implement {IERC721Receiver-onERC721Received}, which is called upon a safe transfer, and return the magic value `bytes4(keccak256("onERC721Received(address,address,uint256,bytes)"))`; otherwise, the transfer is reverted. Requires the msg.sender to be the owner, approved, or operator',
        params: {
          from: "current owner of the token",
          to: "address to receive the ownership of the given token ID",
          tokenId: "uint256 ID of the token to be transferred",
        },
      },
      "safeTransferFrom(address,address,uint256,bytes)": {
        details:
          'Safely transfers the ownership of a given token ID to another address If the target address is a contract, it must implement {IERC721Receiver-onERC721Received}, which is called upon a safe transfer, and return the magic value `bytes4(keccak256("onERC721Received(address,address,uint256,bytes)"))`; otherwise, the transfer is reverted. Requires the _msgSender() to be the owner, approved, or operator',
        params: {
          _data: "bytes data to send along with a safe transfer check",
          from: "current owner of the token",
          to: "address to receive the ownership of the given token ID",
          tokenId: "uint256 ID of the token to be transferred",
        },
      },
      "setApprovalForAll(address,bool)": {
        details:
          "Sets or unsets the approval of a given operator An operator is allowed to transfer all tokens of the sender on their behalf.",
        params: {
          approved: "representing the status of the approval to be set",
          to: "operator address to set the approval",
        },
      },
      "supportsInterface(bytes4)": {
        details:
          "See {IERC165-supportsInterface}.     * Time complexity O(1), guaranteed to always use less than 30 000 gas.",
      },
      "tokenByIndex(uint256)": {
        details:
          "Gets the token ID at a given index of all the tokens in this contract Reverts if the index is greater or equal to the total number of tokens.",
        params: {
          index: "uint256 representing the index to be accessed of the tokens list",
        },
        return: "uint256 token ID at the given index of the tokens list",
      },
      "tokenOfOwnerByIndex(address,uint256)": {
        details: "Gets the token ID at a given index of the tokens list of the requested owner.",
        params: {
          index: "uint256 representing the index to be accessed of the requested tokens list",
          owner: "address owning the tokens list to be accessed",
        },
        return: "uint256 token ID at the given index of the tokens list owned by the requested address",
      },
      "totalSupply()": {
        details: "Gets the total amount of tokens stored by the contract.",
        return: "uint256 representing the total amount of tokens",
      },
      "transferFrom(address,address,uint256)": {
        details:
          "Transfers the ownership of a given token ID to another address. Usage of this method is discouraged, use {safeTransferFrom} whenever possible. Requires the msg.sender to be the owner, approved, or operator.",
        params: {
          from: "current owner of the token",
          to: "address to receive the ownership of the given token ID",
          tokenId: "uint256 ID of the token to be transferred",
        },
      },
      "transferOwnership(address)": {
        details:
          "Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.",
      },
    },
  },
  userdoc: {
    methods: {},
  },
};
